import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clearMemberTransactions, getMemberTransactions, memberHasMoreTransactionResults } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useEffect, useReducer } from 'react';
import { useOccConfig } from '../../context/occ/hooks/use-occ-config';
import { Button } from '../../subcomponents/button/button';
import { ButtonColor } from '../../subcomponents/button/types/color';
import { ButtonSize } from '../../subcomponents/button/types/size';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { MemberTransactionListMessage } from './subcomponents/message';
import { MemberTransactionListSkeleton } from './subcomponents/skeleton';
import { MemberTransactionListTable } from './subcomponents/table';
import { mapMemberTransactionListContext, MemberTransactionListContextInstance } from './types/context';
import { defaultMemberTransactionListProps, memberTransactionListPropsValidator } from './types/props';
import { defaultMemberTransactionListState } from './types/state';
import { memberTransactionListActionReducer } from './utils/action-reducer';
import { loadNextTransactions } from './utils/load-next-transactions';
const b = bemClassBuilder('v-member-transaction-list');
export const MemberTransactionList = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const [state, dispatch] = useReducer(memberTransactionListActionReducer, defaultMemberTransactionListState);
    const { errorMessageType, isLoading, failedToLoadTransactions } = state;
    const { displayText, config } = props;
    const { numberOfTransactionsToLoad } = config;
    const context = mapMemberTransactionListContext(props);
    const transactions = getMemberTransactions();
    const hasMoreResults = memberHasMoreTransactionResults();
    useEffect(() => {
        loadNextTransactions(dispatch, numberOfTransactionsToLoad);
        return clearMemberTransactions;
    }, [numberOfTransactionsToLoad]);
    const handleLoadButtonClicked = () => {
        loadNextTransactions(dispatch, numberOfTransactionsToLoad);
    };
    if (errorMessageType) {
        return (_jsx(MemberTransactionListContextInstance.Provider, Object.assign({ value: context }, { children: _jsx(MemberTransactionListMessage, { messageType: errorMessageType }) })));
    }
    if (!failedToLoadTransactions && !transactions.length) {
        return enableSkeletonLoadingIndicators ? _jsx(MemberTransactionListSkeleton, {}) : null;
    }
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx(MemberTransactionListContextInstance.Provider, Object.assign({ value: context }, { children: _jsx(MemberTransactionListTable, {}) })), hasMoreResults && (_jsx(Button, { className: b.element('load-more-button'), color: ButtonColor.Secondary, size: ButtonSize.Small, loading: isLoading, label: displayText.buttonLoadMoreLabel, onClick: handleLoadButtonClicked }))] })));
});
MemberTransactionList.displayName = 'MemberTransactionList';
/**
 * The **Member Transaction List** component renders a member's past transactions, balance earnings, and redemptions.
 */
export const MemberTransactionListComponent = withComponentWrapper(MemberTransactionList, defaultMemberTransactionListProps, memberTransactionListPropsValidator);
